import React, { useCallback, useEffect, useRef } from "react";
import { useNewton } from "../../store/NewtonContext";
import { suggestions as starterSuggestions } from "../../constants/suggestions";
import { generateNextSuggestions } from "../../utils/suggestions";
import { Message } from "./Message";
import { SuggestionRail } from "./SuggestionRail";

const StarterSuggestions = ({ onSuggestion }) => (
  <div>
    <div className="text-grayTrue400 mb-2 text-xs font-semibold">
      Newton is here to help:
    </div>
    <div className="flex flex-wrap gap-2.5">
      <SuggestionRail onClick={onSuggestion} suggestions={starterSuggestions} />
    </div>
  </div>
);

const NextSuggestions = ({ onSuggestion, suggestions }) =>
  suggestions?.length ? (
    <div className="mt-2">
      <div className="text-grayTrue400 mb-2 text-xs font-semibold">
        What&apos;s next
      </div>
      <div className="flex flex-wrap gap-2.5">
        <SuggestionRail onClick={onSuggestion} suggestions={suggestions} />
      </div>
      <div className="text-grayTrue400 mt-2 text-xs font-semibold">
        Ask something else
      </div>
    </div>
  ) : null;

const MessageList = ({ messagesHistory, nextSuggestions, onSuggestion }) => (
  <div className="flex flex-col gap-2">
    {messagesHistory.map((messageItem) => {
      const isUser = messageItem.from === "user";
      return (
        <React.Fragment key={messageItem.timestamp + messageItem.message}>
          <Message messageItem={messageItem} />
          {!isUser && !messageItem.pending && (
            <NextSuggestions
              onSuggestion={onSuggestion}
              suggestions={nextSuggestions}
            />
          )}
        </React.Fragment>
      );
    })}
  </div>
);

export function Body({ textareaRef }) {
  const { messagesHistory, setMessage, setMessageHtml } =
    useNewton();
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messagesHistory]);

  const onSuggestion = useCallback(
    (text) => {
      setMessage(text);
      setMessageHtml(text);
      textareaRef.current?.focus();
    },
    [setMessage, setMessageHtml, textareaRef]
  );

  const hasHistory = messagesHistory?.length > 0;
  const nextSuggestions = hasHistory
    ? generateNextSuggestions(messagesHistory, { max: 3 })
    : [];

  return (
    <>
      <div ref={bottomRef} />
      {hasHistory ? (
        <MessageList
          messagesHistory={messagesHistory}
          nextSuggestions={nextSuggestions}
          onSuggestion={onSuggestion}
        />
      ) : (
        <StarterSuggestions onSuggestion={onSuggestion} />
      )}
    </>
  );
}
